module.exports = __webpack_public_path__ + "static/media/Internet.b9a2c1a8.svg";